import { Colors, MagicBox } from "@brg/ui";
import { LayoutConst } from "core";
import styled from "styled-components";

export const QueueRateChooser = styled.div`
    display: flex;
    gap: 12px
`

export const QueueRateItem = styled(MagicBox)<{
    selected?: boolean
    bgColor: string
}>`
    cursor: pointer;
    font-family: Inter;
    font-size: 15px;
    font-weight: 400;
    line-height: 20px;
    letter-spacing: -0.02em;
    color: ${Colors.galBlack100};

    border-radius: 5px;
    padding: 5px 16px;
    box-sizing: border-box;
    border: ${p => `1px solid ${p.selected ? p.bgColor : Colors.galBlack31}`};
    background-color: ${p => p.selected && p.bgColor ? p.bgColor : "transparent"}
`

export const QueuePriceInputWrapper = styled.div`
    display: flex;
    align-items: center;
    gap: 24px;

    @media screen and (max-width: ${LayoutConst.screen.s}px) {
        flex-direction: column;
        align-items: flex-start;
        gap: 8px;
        width: 100%;
    }
`

export const QueueBottomLabel = styled.div`
    font-family: Inter;
    font-size: 13px;
    font-weight: 400;
    line-height: 16px;

    color: ${Colors.galBlack47};
`

export const QueuePriceInput = styled.input<{color?: string, fs?: number, lh?: number, minWidth?: number, maxWidth?: number}>`
    font-family: Inter;
    font-size: ${p => p.fs || 13}px;
    font-weight: 400;
    line-height: ${p => p.lh || 16}px;
    color: ${p => p.color || Colors.galBlack100};

    border: none;
    outline: none;
    
    box-sizing: border-box;
    min-width: ${p => p.minWidth || 168}px;
    max-width: ${p => p.maxWidth + 'px' || 'auto'};
    padding: 16px;
    background-color: ${Colors.galBlack5};
    border-radius: 3px;
    width: 120px;
    
    &:disabled {
        color: ${Colors.galBlack31}
    }

    @media screen and (max-width: ${LayoutConst.screen.sm}px) {
        width: 100%
    }
`

export const QueueUploadPriceWrapper = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
`

export const QueueUploadPrice = styled.div<{ nonMinWidth?: boolean }>`
    display: flex;
    align-items: center;
    font-family: Inter;
    font-size: 22px;
    font-weight: 600;
    line-height: 28px;
    letter-spacing: -0.02em;
    text-align: left;
    justify-content: flex-end;
    min-width: ${({nonMinWidth}) => nonMinWidth ? 'none' : '80px'};
    color: ${Colors.galBlack100};
`

export const TitleHint = styled(MagicBox)`
    font-family: Inter;
    font-size: 15px;
    font-style: normal;
    font-weight: 600;
    border: 1px solid #B6B6B5;
    color: #B6B6B5;
    border-radius: 50%;
    width: 32px;
    min-width: 32px;
    height: 32px;
`
import { Colors, MagicBox } from "@brg/ui";
import { LayoutConst } from "core";
import styled from "styled-components";

export const QueueRateChooser = styled.div`
    display: flex;
    gap: 12px
`

export const QueueRateItem = styled(MagicBox)<{
    selected?: boolean
    bgColor: string
}>`
    cursor: pointer;
    font-family: Inter;
    font-size: 15px;
    font-weight: 400;
    line-height: 20px;
    letter-spacing: -0.02em;
    color: ${Colors.galBlack100};

    border-radius: 5px;
    padding: 5px 16px;
    box-sizing: border-box;
    border: ${p => `1px solid ${p.selected ? p.bgColor : Colors.galBlack31}`};
    background-color: ${p => p.selected && p.bgColor ? p.bgColor : "transparent"}
`

export const QueuePriceInputWrapper = styled.div`
    display: flex;
    align-items: center;
    gap: 24px;

    @media screen and (max-width: ${LayoutConst.screen.s}px) {
        flex-direction: column;
        align-items: flex-start;
        gap: 8px;
        width: 100%;
    }
`

export const QueueBottomLabel = styled.div`
    font-family: Inter;
    font-size: 13px;
    font-weight: 400;
    line-height: 16px;

    color: ${Colors.galBlack47};
`

export const QueuePriceInput = styled.input<{color?: string, fs?: number, lh?: number, minWidth?: number, maxWidth?: number}>`
    font-family: Inter;
    font-size: ${p => p.fs || 13}px;
    font-weight: 400;
    line-height: ${p => p.lh || 16}px;
    color: ${p => p.color || Colors.galBlack100};

    border: none;
    outline: none;
    
    box-sizing: border-box;
    min-width: ${p => p.minWidth || 168}px;
    max-width: ${p => p.maxWidth + 'px' || 'auto'};
    padding: 16px;
    background-color: ${Colors.galBlack5};
    border-radius: 3px;
    width: 120px;
    
    &:disabled {
        color: ${Colors.galBlack31}
    }

    @media screen and (max-width: ${LayoutConst.screen.sm}px) {
        width: 100%
    }
`

export const QueueUploadPriceWrapper = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
`

export const QueueUploadPrice = styled.div<{ nonMinWidth?: boolean }>`
    display: flex;
    align-items: center;
    font-family: Inter;
    font-size: 22px;
    font-weight: 600;
    line-height: 28px;
    letter-spacing: -0.02em;
    text-align: left;
    justify-content: flex-end;
    min-width: ${({nonMinWidth}) => nonMinWidth ? 'none' : '80px'};
    color: ${Colors.galBlack100};
`

export const TitleHint = styled(MagicBox)`
    font-family: Inter;
    font-size: 15px;
    font-style: normal;
    font-weight: 600;
    border: 1px solid #B6B6B5;
    color: #B6B6B5;
    border-radius: 50%;
    width: 32px;
    min-width: 32px;
    height: 32px;
`
